import { render } from "./TheRechargesList.vue?vue&type=template&id=08264a18"
import script from "./TheRechargesList.vue?vue&type=script&lang=js"
export * from "./TheRechargesList.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__